import { ICopyable, IJsonSerializable } from '../util/interfaces'
import { Enums } from '../common/enums'

export class OpConsumerNotificationToSend implements IJsonSerializable, ICopyable<OpConsumerNotificationToSend> {

    // #region Properties

    public idConsumer: number
    public text: string
    public notificationDeliveryTypes: Enums.NotificationDeliveryType[]

    // #endregion


    // #region Ctor

    constructor(opObj: any = null) {
        if (opObj instanceof OpConsumerNotificationToSend) {
            this.copy(<OpConsumerNotificationToSend>opObj, true, true, true, true)
        } else {
            this.fromJSON(opObj)
        }
    }

    // #endregion


    // #region IJsonSerializable implementation

    public fromJSON(opObj: any, compress: boolean = false) {
        if (opObj) {
            this.idConsumer = opObj.IdConsumer
            this.text = opObj.Text
            this.notificationDeliveryTypes = opObj.NotificationDeliveryTypes
        }
    }

    public toJSON(compress: boolean = false): any {
        return {
            IdConsumer: this.idConsumer,
            Text: this.text,
            NotificationDeliveryTypes: this.notificationDeliveryTypes,
        }
    }

    // #endregion


    // #region ICopyable

    public clone(includeNavigationProperties: boolean, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): OpConsumerNotificationToSend {
        const consumerNotificationToSend: OpConsumerNotificationToSend = new OpConsumerNotificationToSend()

        consumerNotificationToSend.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return consumerNotificationToSend
    }

    public copy(source: OpConsumerNotificationToSend, includeNavigationProperties: boolean, includeCustomProperties: boolean, includeDataList: boolean, includeDynamicValues: boolean): void {

        if (source == null) {
            return null
        }

        if (includeNavigationProperties) {
            // No Navigation Properties
        }

        if (includeCustomProperties) {
            // No Custom Properties
        }

        if (includeDataList) {
            // No Data List
        }

        if (includeDynamicValues) {
            // No Dynamic Values
        }

        this.idConsumer = source.idConsumer
        this.text = source.text
        this.notificationDeliveryTypes = source.notificationDeliveryTypes
    }

    // #endregion 
}